import { render, staticRenderFns } from "./Campaigndashboard.vue?vue&type=template&id=0cf37885&"
import script from "./Campaigndashboard.vue?vue&type=script&lang=js&"
export * from "./Campaigndashboard.vue?vue&type=script&lang=js&"
import style0 from "./Campaigndashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports